import React, { useState } from "react";

import * as TablerIcons from "@tabler/icons-react";

const Sidebar = ({
  categories,
  selectedCategory,
  handleFilterByCategory,
  setSelectedCategory,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <aside
      className="p-1 border-end bg-light"
      style={{
        width: isExpanded ? "200px" : "60px", // 🔹 Hover: Lebar berubah dari 60px → 200px
        transition: "width 0.3s ease-in-out",
        overflow: "hidden",
        whiteSpace: "nowrap",
        position: "fixed",
        height: "100vh",
        zIndex: 1000,
      }}
      onMouseEnter={() => setIsExpanded(true)}
      onMouseLeave={() => setIsExpanded(false)}
    >
      <h5 className="text-center">{isExpanded ? "Kategori" : "📁"}</h5>
      <button
        className={`btn d-flex align-items-center w-100 my-2 text-start ${
          selectedCategory === "All" ? "btn-dark" : "btn-light"
        }`}
        onClick={() => {
          setSelectedCategory("All");
          handleFilterByCategory("");
        }}
        style={{ padding: "10px", fontSize: "16px" }}
      >
        All
      </button>

      {categories.map((category) => {
        const IconComponent =
          TablerIcons[category.icon] || TablerIcons.IconQuestionMark;

        return (
          <>
            <button
              key={category.name}
              className={`btn d-flex align-items-center w-100 my-2 text-start ${
                selectedCategory === category.name
                  ? `btn-${category.color}`
                  : "btn-light"
              }`}
              // onClick={() => onSelectCategory(category.name)}
              onClick={() => {
                setSelectedCategory(category.name);
                handleFilterByCategory(category.id);
              }}
              
              style={{ padding: "10px", fontSize: "16px" }}
            >
              <IconComponent className="me-2" size={isExpanded ? 32 : 24} />
              {isExpanded ? category.name : category.name.charAt(0)}
            </button>
          </>
        );
      })}
    </aside>
  );
};

export default Sidebar;
